import React from 'react';
import {Icon} from '../Icon/Icon';
import styles from './KebabButton.module.css';

interface Props {
  isOpen: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
  ariaLabel?: string;
}

const KebabButton = React.forwardRef<HTMLButtonElement, Props>(
  ({isOpen, onClick, disabled, className = '', children, ariaLabel}, ref) => (
    <button
      ref={ref}
      type="button"
      className={`${styles.opener} ${
        isOpen ? styles.openerOpen : ''
      } ${className}`}
      aria-expanded={isOpen}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}>
      <span className={styles.glyph}>
        {children || <Icon name="dots-horizontal.svg" />}
      </span>
    </button>
  ),
);

export default KebabButton;
